var render, staticRenderFns
import script from "./MetricsChart.vue?vue&type=script&lang=js"
export * from "./MetricsChart.vue?vue&type=script&lang=js"
import style0 from "./MetricsChart.vue?vue&type=style&index=0&id=2f7480b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7480b4",
  null
  
)

export default component.exports